import React from 'react'
import { Button as MuiButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import SearchButton from './SearchButton'
import FiltersButton from './FiltersButton'
import ApplyFiltersButton from './ApplyFiltersButton'
import BackButton from './BackButton'
import SortButton from './SortButton'
import DetailsButton from './DetailsButton'
import DeleteButton from './DeleteButton'
import { Loader } from 'packages/eid-ui'
import RequestAccessButton from './RequestAccessButton'
import EditButton from './EditButton'
import CancelButton from './CancelButton'
import SaveButton from './SaveButton'

const styles = {
    small: {
        padding: '3.25px 20px',
        minHeight: '35px',
    },
    medium: {
        padding: '5.25px 15px',
        minHeight: '39px',
    },
    large: {
        padding: '9.25px 30px',
        minHeight: '47px',
    },
}

const StyledButton = styled(MuiButton)(
    ({ theme, size, style, disabledStyles }) => ({
        textTransform: 'capitalize',
        fontSize: '16px',
        border: '1px solid transparent',
        borderRadius: '5px',
        lineHeight: 'normal',
        minHeight: '32px',
        height: 'unset !important',
        paddingTop: '5px',
        paddingBottom: '5px',
        ...styles[size],
        ...style,
        '&.Mui-disabled': {
            ...disabledStyles,
        },
        '&.MuiButton-startIcon': {
            marginRight: size === 'large' ? '14px' : '10px',
        },
    }),
)

const Button = (props) => {
    const {
        size,
        children,
        style,
        disabledStyles,
        loading,
        loaderColor,
        startIcon,
        endIcon,
        onClick,
        ...rest
    } = props

    return (
        <StyledButton
            startIcon={!loading && startIcon}
            endIcon={!loading && endIcon}
            onClick={!loading ? onClick : undefined}
            style={style}
            disabledStyles={disabledStyles}
            {...rest}
        >
            {!loading ? (
                children
            ) : (
                <Loader
                    color={loaderColor ? loaderColor : '#ffffff'}
                    size={0.6}
                    height="0.5inh"
                    style={{ backgroundColor: 'transparent' }}
                />
            )}
        </StyledButton>
    )
}

Button.Search = SearchButton
Button.Filters = FiltersButton
Button.ApplyFilters = ApplyFiltersButton
Button.BackButton = BackButton
Button.Sort = SortButton
Button.Details = DetailsButton
Button.Delete = DeleteButton
Button.Edit = EditButton
Button.RequestAccess = RequestAccessButton
Button.Save = SaveButton
Button.Cancel = CancelButton

export default Button
